module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.fa2772327f55d8198301.woff";


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/assets/fonts/glyphicons-halflings-regular.woff
// module id = ../../../../../client/assets/fonts/glyphicons-halflings-regular.woff
// module chunks = styles